















import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { feedBackInitialValue } from '@/types/feedBack';
import FeedBackInterface from '@/types/feedBack';

@Component({})
export default class FeedBack extends Vue {
  @Getter('getFeedBack', { namespace: 'feedBack' })
  public feedBack!: FeedBackInterface;


  @Action('setFeedback', { namespace: 'feedBack' })
  setFeedBack!: (feedback: FeedBackInterface) => void;
  public closeFeedBack(): void {
    this.setFeedBack(feedBackInitialValue);
  }
}
